interface SectionHeaderProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeader({ kicker, title, desc, align = 'left' }: SectionHeaderProps) {
  const centered = align === 'center';
  return (
    <div className={`flex flex-col ${centered ? 'items-center text-center' : ''} mb-6 md:mb-9`}>
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide">
        <i className="ri-sparkling-2-line text-sm w-4 h-4 flex items-center justify-center" />
        {kicker}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">{title}</h2>
      {desc && (
        <p className={`mt-3 text-sm md:text-base text-foreground-600 max-w-2xl ${centered ? 'mx-auto' : ''}`}>
          {desc}
        </p>
      )}
    </div>
  );
}